<app-simple-grid
  [listOperator]="listRentalAgreementValuesOperator"
  [createOperator]="createRentalAgreementValueOperator"
  [updateOperator]="updateRentalAgreementValueOperator"
  [detailsOperator]="detailsRentalAgreementValueOperator"
  [deleteOperator]="deleteRentalAgreementValueOperator"
  [rowActionSelector]="selectedRowActionFilter"
  [baseActions]="actions()"
  [columnDefs]="columnDefs"
  [deselectRowSignal]="deselectRowSignal$"
  [enablePagination]="false" />
